const signUpConfig = {
	allowLogin: true,
	allowSignUp: true,
	redirectUri: window.location.origin,
	initialScreen: 'forgotPassword',
};

export default signUpConfig;
